<ng-template #modal>
  <div class="modal-header">
    <div class="modal-header-title">
      <h4 class="modal-title pull-left">Responsável</h4>
      <h5 class="modal-subtitle" *ngIf="objetos[0]?.title || objetos[0]?.description">
        {{objetos[0]?.title ? objetos[0]?.title : objetos[0]?.description}}
      </h5>
    </div>
    <button type="button" class="btn-close close pull-right" aria-label="Close" (click)="closeModal()">
      <span aria-hidden="true" class="visually-hidden">&times;</span>
    </button>
  </div>
  <div class="modal-body">

    <div class="responsavel">
      <ng-container *ngFor="let item of objetos; let i = index">
        <ul *ngIf="item?.resp_nome">
          <li>
            <div>{{item?.id || item?.prt_issue_id || item?.ind_id ? 'Resp' : 'Adj'}}:</div> <span class="nome">{{item?.resp_nome}}</span>
          </li>
          <li *ngIf="item?.resp_email">
            <div>E-mail:</div> {{item?.resp_email}}
          </li>
          <li *ngIf="item?.resp_tel">
            <div>Telefone:</div> {{item?.resp_tel}}
          </li>
        </ul>
        <hr>
      </ng-container>
    </div>
  </div>
</ng-template>